import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import { convertDate } from '@/global.js'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

// Retorna os cadastros
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_cpf - CPF do profissional
 */
export async function getCadastros(cod_ibge, nu_cpf) {
  try {
    const { data } = await api.post('/app/comorbidades/profissional', {
      cod_ibge: cod_ibge,
      cpf: nu_cpf,
    })
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros por equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getCadastrosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await api.get(
      '/app/comorbidades/equipe/' + cod_ibge + '/' + nu_ine
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

export function generatePdf(cadastros, selectEquipe, nomeProfissional) {
  let title_pdf = 'Condições Saúde'
  let titlePdfSave = utils.methods.titlePdf(
    'Condições Saúde',
    selectEquipe.no_equipe
  )
  let description_pdf = 'Situação e condições de saúde por cidadão'
  let headers_pdf = [
    'NOME',
    'DATA DE NASCIMENTO',
    'NOME DA MÃE',
    'MICRO ÁREA',
    'CONDIÇÕES DE SAÚDE',
    'MÉDICO(A)',
    'ENFERMEIRO(A)',
    'ODONTÓLOGO(A)',
    'ACS',
    'DOCUMENTO',
  ]
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento = convertDate(cadastros[i].dt_nascimento)
    obj.no_mae = cadastros[i].no_mae
    obj.micro_area = cadastros[i].micro_area
    /*  obj.comorbidades = cadastros[i].comorbidades
      .map((comorbidade) => comorbidade.label)
      .join(', ') */
    obj.comorbidades = filtrarComorbidades(cadastros[i].comorbidades)
      .map((c) => c.label)
      .join(', ')
    obj.medico = convertDate(cadastros[i].dt_atendimento_medico)
    obj.enfermeiro = convertDate(cadastros[i].dt_atendimento_enfermeiro)
    obj.odontologo = convertDate(cadastros[i].dt_atendimento_odonto)
    obj.acs = convertDate(cadastros[i].dt_visita)
    let documentoText = ''
    let lineBreak = ''
    if (cadastros[i].nu_cpf !== null && cadastros[i].nu_cpf !== undefined) {
      lineBreak = '\n'
      documentoText += `CPF ${cadastros[i].nu_cpf}`
    }
    if (cadastros[i].nu_cns !== null && cadastros[i].nu_cns !== undefined) {
      documentoText += `${lineBreak}CNS ${cadastros[i].nu_cns}`
    }
    obj.documento = documentoText
    data_pdf.push(obj)
  }
  let doc = new jsPDF({
    orientation: 'l',
  })
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf,
        287
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Profissional ACS',
            value: nomeProfissional,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY, 90, 205)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const doencas = [
  { label: 'Todas', value: 'todas' },
  { label: 'Acamado', value: 'acamado' },
  { label: 'Câncer', value: 'cancer' },
  { label: 'Deficiências', value: 'def' },
  { label: 'AVC', value: 'st_avc' },
  { label: 'Doenças cardíacas', value: 'doencaCardiaca' },
  { label: 'Doenças nos rins', value: 'doencaRins' },
  { label: 'Doenças respiratórias', value: 'doencaRespiratoria' },
  { label: 'Domiciliado', value: 'domiciliado' },
  { label: 'Diabetes', value: 'st_diabetes' },
  { label: 'Fumante', value: 'fumante' },
  { label: 'Gestante', value: 'gestante' },
  { label: 'Hanseníase', value: 'hanseníase' },
  { label: 'Hipertensão', value: 'st_hipertensao_arterial' },
  { label: 'Hipertensos e diabéticos', value: 'hiperdia' },
  { label: 'Infarto', value: 'infarto' },
  { label: 'Internação recente', value: 'internacaoRecente' },
  { label: 'Morador de rua', value: 'moradorDeRua' },
  { label: 'Usa álcool', value: 'usaAlcool' },
  { label: 'Usa drogas', value: 'usaDrogras' },
  { label: 'Problema saúde mental', value: 'tratamentoPsiquiátrico' },
  { label: 'Tuberculose', value: 'Tuberculose' },
  { label: 'Sem comorbirdade', value: 'semComorbirdades' },
  { label: 'Com alguma comorbidade', value: 'comAlgumaComorbidade' },
]
export const labelsDoenca = {
  Acamado: 'st_acamado',
  Câncer: 'st_cancer',
  Deficiências: [
    'st_deficiencia',
    'st_defi_auditiva',
    'st_defi_intelectual_cognitiva',
    'st_defi_outra',
    'st_defi_visual',
    'st_defi_fisica',
  ],
  AVC: 'st_avc',
  'Doenças cardíacas': [
    'st_doenca_cardiaca',
    'st_doenca_card_insuficiencia',
    'st_doenca_card_outro',
  ],
  'Doenças nos rins': [
    'st_problema_rins',
    'st_problema_rins_insuficiencia',
    'st_problema_rins_outro',
  ],
  'Doenças respiratórias': [
    'st_doenca_respiratoria',
    'st_doenca_respira_asma',
    'st_doenca_respira_dpoc_enfisem',
    'st_doenca_respira_outra',
  ],
  Domiciliado: 'st_domiciliado',
  Fumante: 'st_fumante',
  Gestante: 'st_gestante',
  Hanseníase: 'st_hanseniase',
  Hipertensão: 'st_hipertensao_arterial',
  Diabetes: 'st_diabetes',
  Infarto: 'st_infarto',
  'Internação recente': 'st_internacao_12',
  'Morador de rua': 'st_morador_rua',
  'Usa álcool': 'st_alcool',
  'Usa drogas': 'st_outra_droga',
  'Problema saúde mental': 'st_tratamento_psiquiatra',
  Tuberculose: 'st_tuberculose',
}
export function getComobidades(data) {
  return data.map((obj) => {
    const comorbidades = []
    Object.entries(labelsDoenca).forEach(([label, value]) => {
      if (Array.isArray(value)) {
        const values = value.filter((v) => obj[v] == 1)
        if (values.length > 0) {
          comorbidades.push({ label, values })
        }
      } else {
        if (obj[value] == 1) {
          comorbidades.push({ label, values: [value] })
        }
      }
    })

    // Check if the comorbidades array has objects with the labels "Diabéticos" and "Hipertensão"
    let hasDiabeticos = false
    let hasHipertensao = false
    for (const comorbidade of comorbidades) {
      if (comorbidade.label === 'Diabetes') {
        hasDiabeticos = true
      }
      if (comorbidade.label === 'Hipertensão') {
        hasHipertensao = true
      }
    }

    // If both "Diabéticos" and "Hipertensão" are found, add a new object with the label "Hipertensos e diabéticos"
    if (hasDiabeticos && hasHipertensao) {
      comorbidades.push({ label: 'Hipertensão e diabetes', values: null })
    }

    // If comorbidades is empty, add an object with the label "Sem comorbidades"
    if (comorbidades.length === 0) {
      comorbidades.push({ label: 'Sem comorbidades', values: null })
    }

    return { ...obj, comorbidades }
  })
}
export function filtrarComorbidades(comorbidades) {
  const temComorbidadeHipertensosDiabeticos = comorbidades.some(
    (comorbidade) => {
      return comorbidade.label === 'Hipertensão e diabetes'
    }
  )

  if (temComorbidadeHipertensosDiabeticos) {
    return comorbidades.filter((comorbidade) => {
      return (
        comorbidade.label !== 'Hipertensão' && comorbidade.label !== 'Diabetes'
      )
    })
  }

  return comorbidades
}
